import { render, staticRenderFns } from "./PublicShareSidebarTrigger.vue?vue&type=template&id=6d5d3930&scoped=true&"
import script from "./PublicShareSidebarTrigger.vue?vue&type=script&lang=js&"
export * from "./PublicShareSidebarTrigger.vue?vue&type=script&lang=js&"
import style0 from "./PublicShareSidebarTrigger.vue?vue&type=style&index=0&id=6d5d3930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5d3930",
  null
  
)

export default component.exports